import { ReactElement } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { formData } from '../../api';
import { AnnouncementFormData } from '../../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  AnnouncementFormData,
  AxiosResultDefaultError
>();

export function useAnnouncementModalLoader() {
  return useFetch();
}

export const AnnouncementModalLoaderConsumer = FetchConsumer;

export default function AnnouncementModalLoader({ children }: BaseLoaderProps) {
  return (
    <FetchProvider request={formData} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
